import { parseTableData } from './parser';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Table from '../../components/Table';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Spinner from '../../components/Spinner';
import SubHeader from '../../components/SubHeader';
import { useToasts } from 'react-toast-notifications';
import EmptyState from '../../components/EmptyState';
import { useSelector } from 'react-redux';

import './styles.scss';
import { getAllTestimonialsService } from '../../services/testimonialsService';

const TestimonialsListing = (props) => {
  const history = useHistory();
  const { addToast } = useToasts();

  const [testimonialsData, setTestimonialsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);

  const auth = useSelector((state) => state.auth);

  const columnHeaders = [
    'S. No.',
    'Name',
    'Clinics',
    'Status',
    'Created',
    'Action',
  ];

  const [userData, setUserData] = useState({
    userName: 'Admin',
    value: 1,
  });

  useEffect(() => {
    if (auth?.authData?.role !== 'admin') {
      let user = {
        userName: 'Super Admin',
        value: 0,
      };
      setUserData({ ...user });
    }
  }, [auth]);

  const handleActionTrigger = (selectedTestimonial) => {
    const testimonialId = selectedTestimonial.id;
    history.push(`/testimonials/edit/${testimonialId}`, {
      page_number: currentPage,
    });
  };

  const getAllTestimonials = (params) => {
    setLoading(true);

    getAllTestimonialsService(params)
      .then((response) => {
        setLoading(false);
        if (response.code === 200) {
          const parsedTableData = parseTableData(
            response?.data?.results,
            response.data?.meta?.pagination
          );

          setTestimonialsData(parsedTableData);

          setTotalPage(response?.data?.meta?.pagination?.total_pages);
        }
      })
      .catch((err) => {
        setLoading(false);
        addToast(err.response?.data?.message, {
          appearance: 'error',
          autoDismiss: true,
        });
      });
  };
  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
    getAllTestimonials({ page: pageNumber, getDefault: true });
  };
  useEffect(() => {
    if (props && props.location?.state?.page_current) {
      setCurrentPage(props.location?.state?.page_current);
      const params = {
        page: props.location?.state?.page_current,
        getDefault: true,
      };
      getAllTestimonials(params);
      props.location.state.page_current = null;
    } else {
      const params = { page: currentPage, getDefault: true };
      getAllTestimonials(params);
    }
  }, []); // eslint-disable-line

  const handleAddTestimonialCta = () => {
    history.push('/testimonials/create', { page_number: currentPage });
  };

  return (
    <div className='testimonials-wrapper'>
      <Header userData={userData} />

      <Sidebar />

      <div className='flexible-container'>
        <SubHeader title='Testimonials' />

        <div className='testimonials-wrapper-content'>
          <div className='testimonials-wrapper-header d-flex align-items-center justify-content-end'>
            <div className='create-cta' onClick={handleAddTestimonialCta}>
              Create New Testimonial
            </div>
          </div>

          {testimonialsData.length ? (
            <Table
              pagination={true}
              columnContent={testimonialsData}
              actionAvailable={true}
              paginationPage={currentPage}
              columnHeaders={columnHeaders}
              paginationTotalPage={totalPage}
              handleAction={handleActionTrigger}
              handlePageNumber={handlePageNumber}
              nextPage={() => {
                setCurrentPage((oldCurrentPage) => oldCurrentPage + 1);
                getAllTestimonials({ page: currentPage + 1, getDefault: true });
              }}
              prevPage={() => {
                setCurrentPage((oldCurrentPage) => oldCurrentPage - 1);
                getAllTestimonials({ page: currentPage - 1, getDefault: true });
              }}
            />
          ) : (
            <EmptyState title='No Testimonials found' />
          )}
        </div>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default TestimonialsListing;
